import  SpDataViewer  from './SpDataViewer';
export default SpDataViewer;
